import clsx from 'clsx';
import React from 'react';
import ChevronDownIcon from '../../assets/icons/chevron-down-icon.svg?react';
import DubbleArrowIcon from '../../assets/icons/dubble-arrow-icon.svg?react';
import Combobox from '../Combobox';

interface PaginationProps {
  otherClasses?: string;
  totalPages: number;
  limit: number;
  showingItems: number;
  totalItems: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  onLimitChange?: (limit: number) => void;
  hiddenCombobox?: boolean;
}

const MOCK_LIMITS = [
  {
    label: '(10) Records',
    value: '10',
  },
  {
    label: '(25) Records',
    value: '25',
  },
  {
    label: '(50) Records',
    value: '50',
  },
  {
    label: '(100) Records',
    value: '100',
  },
  {
    label: '(500) Records',
    value: '500',
  },
];
const Pagination: React.FC<PaginationProps> = ({
  otherClasses,
  limit,
  totalItems,
  totalPages,
  currentPage,
  showingItems,
  onPageChange,
  onLimitChange,
  hiddenCombobox,
}) => {
  const paginationClasses = clsx(
    otherClasses,
    'py-12 flex w-full flex-col items-center justify-between gap-6 xl:flex-row xl:gap-0 ',
  );

  const handleNext = (isAll: string) => {
    if (isAll === 'all') {
      onPageChange(totalPages);
    } else if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePrev = (isAll: string) => {
    if (isAll === 'all') {
      onPageChange(1);
    } else if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  return (
    <div className={paginationClasses} data-testid="pagination">
      <Combobox
        value={limit.toString()}
        list={MOCK_LIMITS}
        onSelect={(e) => onLimitChange?.(Number(e))}
        label="Rows Per Page"
        key={limit.toString()}
        placeholder="Rows per page"
        totalItems={totalItems}
        hidden={hiddenCombobox}
      />
      <div className="flex w-full items-stretch justify-between gap-2.5 xl:w-auto xl:justify-start">
        <p className="text-neutral-tones-text/40 -tracking-form-input lg:-tracking-button flex items-center gap-2 text-base leading-5 font-medium lg:text-lg lg:leading-6">
          SHOWING {showingItems}-{limit} OF {totalItems}
        </p>
        <span className="border-l-neutral-tones-text/10 border-l"></span>
        <p className="text-neutral-tones-text/40 -tracking-form-input lg:-tracking-button text-base leading-5 font-medium lg:text-lg lg:leading-6 xl:hidden">
          PAGE <span className="text-brand-byzantine">{currentPage}</span> OF{' '}
          <span className="text-brand-byzantine">{totalPages}</span>
        </p>
      </div>

      <div className="flex w-full items-stretch justify-between gap-15 xl:w-auto xl:justify-start">
        <button
          type="button"
          onClick={() => handlePrev('all')}
          className="border-neutral-tones-text/10 bg-card-backgrounds/5 rounded-10 cursor-pointer border p-1"
        >
          <DubbleArrowIcon className="[&>g>path]:fill-neutral-tones-text h-8 w-8 lg:h-10 lg:w-10" />
        </button>
        <span className="border-l-neutral-tones-text/10 border-l"></span>
        <div className="flex items-center justify-around gap-15">
          <button
            type="button"
            onClick={() => handlePrev('')}
            className="border-neutral-tones-text/10 bg-card-backgrounds/5 rounded-10 cursor-pointer border p-1"
          >
            <ChevronDownIcon className="[&>path]:fill-neutral-tones-text h-8 w-8 rotate-90 lg:h-10 lg:w-10" />
          </button>
          <p className="text-neutral-tones-text/40 -tracking-button hidden text-lg leading-6 font-medium xl:block">
            PAGE <span className="text-brand-byzantine">{currentPage}</span> OF{' '}
            <span className="text-brand-byzantine">{totalPages}</span>
          </p>
          <button
            type="button"
            onClick={() => handleNext('')}
            className="border-neutral-tones-text/10 bg-card-backgrounds/5 rounded-10 cursor-pointer border p-1"
          >
            <ChevronDownIcon className="[&>path]:fill-neutral-tones-text h-8 w-8 -rotate-90 lg:h-10 lg:w-10" />
          </button>
        </div>
        <span className="border-l-neutral-tones-text/10 border-l"></span>
        <button
          type="button"
          onClick={() => handleNext('all')}
          className="border-neutral-tones-text/10 bg-card-backgrounds/5 rounded-10 cursor-pointer border p-1"
        >
          <DubbleArrowIcon className="[&>g>path]:fill-neutral-tones-text h-8 w-8 rotate-180 lg:h-10 lg:w-10" />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
